export default {
	"181c94ea9df20f32666476fdac3b4046": "I have purchased this product"
}
